import {useEffect, useState} from 'react';

import {isInaccessibleStorable, MinimalContainer} from 'constants/SampleConstants';
import {bulkPreloadContainerContentTablesQueryForContents} from 'samples/ContainerContentTables';
import {GridWithLoading} from 'samples/StorableStore';

/**
 * A hook to preload sample aliquot numbers (referred to as lots internally) for all the containers in a grid entity.
 */
export default function useGridContentLots(grid: GridWithLoading): void {
  const [contentLotsLoaded, setContentLotsLoaded] = useState(false);
  useEffect(() => {
    if (!contentLotsLoaded) {
      const containerIds: Array<string> = grid.cells.flatMap((row) =>
        row
          .filter((cell) => cell?.container != null && !isInaccessibleStorable(cell.container))
          .map((cell) => (cell!.container as MinimalContainer).id)
      );
      bulkPreloadContainerContentTablesQueryForContents(containerIds);
      setContentLotsLoaded(true);
    }
  }, [contentLotsLoaded, grid.cells]);
}
